module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_07_07_us_falcon-heights-shooting-minnesota_index.html_plot.b14cb575.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_07_07_us_falcon-heights-shooting-minnesota_index.html_plot.png
// module id = 373
// module chunks = 0